export const shadows = {
  card: '0px 0px 2px rgba(40, 41, 61, 0.04), 0px 4px 8px rgba(96, 97, 112, 0.16)',
  button: {
    focus:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
  },
  dialog: '0px 5px 25px rgba(51, 51, 51, 0.13)',
  popover:
    '0px 0px 2px rgba(87, 89, 123, 0.04), 0px 4px 8px rgba(87, 89, 123, 0.16)',
  select: '0px 12px 32px rgba(38, 39, 59, 0.13)',
  mapZoom: '0px 1px 2px rgba(38, 39, 59, 0.1), 0px 2px 4px rgba(38, 39, 59, 0.2)',
};
